/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_1_Task_Focus_OnceInputs */

const en_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete 1 focus session`)
};

const ar_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمِل جلسة تركيز واحدة`)
};

const de_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Fokus-Sitzung abschließen`)
};

const es_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 1 sesión de concentración`)
};

const fr_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compléter 1 session de concentration`)
};

const it_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 1 sessione di concentrazione`)
};

const ja_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーカスを1回完了`)
};

const ko_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 1회 완료하기`)
};

const pt_br_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua 1 sessão de foco`)
};

const ru_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершите 1 фокусировку`)
};

const th_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสให้เสร็จสิ้น 1 ครั้ง`)
};

const tr_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Odaklanma Tamamla`)
};

const zh_cn_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 1 次专注`)
};

const zh_tw_phase_1_task_focus_once = /** @type {(inputs: Phase_1_Task_Focus_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 1 次專注`)
};

/**
* | output |
* | --- |
* | "Complete 1 focus session" |
*
* @param {Phase_1_Task_Focus_OnceInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_1_task_focus_once = /** @type {((inputs?: Phase_1_Task_Focus_OnceInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_1_Task_Focus_OnceInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_1_task_focus_once(inputs)
	if (locale === "ar") return ar_phase_1_task_focus_once(inputs)
	if (locale === "de") return de_phase_1_task_focus_once(inputs)
	if (locale === "es") return es_phase_1_task_focus_once(inputs)
	if (locale === "fr") return fr_phase_1_task_focus_once(inputs)
	if (locale === "it") return it_phase_1_task_focus_once(inputs)
	if (locale === "ja") return ja_phase_1_task_focus_once(inputs)
	if (locale === "ko") return ko_phase_1_task_focus_once(inputs)
	if (locale === "pt_br") return pt_br_phase_1_task_focus_once(inputs)
	if (locale === "ru") return ru_phase_1_task_focus_once(inputs)
	if (locale === "th") return th_phase_1_task_focus_once(inputs)
	if (locale === "tr") return tr_phase_1_task_focus_once(inputs)
	if (locale === "zh_cn") return zh_cn_phase_1_task_focus_once(inputs)
	return zh_tw_phase_1_task_focus_once(inputs)
});